import React, { Component } from 'react';
import { MenuItem, Paper, TextField } from 'material-ui';
import { Field, reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import { renderInput } from 'src/components/misc/redux-form-helpers';
import { isBlank } from 'src/components/misc/validations';

class CustomFeeMapForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: true,
            searchTerm: '',
            open: false,
            filteredOptions: this.props.busCompanies || [],
            selectedOperator: null,
        };
    }

    handleSuggestionClick = option => {
        this.setState({
            searchTerm: option != null ? option.companyName : '',
            open: false,
        });

        this.props.change('companyId', option != null && option.id != null ? option.id : null);
        this.props.change('company', option != null ? option : null);

        // Trigger external callbacks if provided
        if (this.props.onOperatorSelect) {
            this.props.onOperatorSelect(option);
        }
    };

    componentDidUpdate(prevProps) {
        const { initialValues } = this.props;
        if (prevProps.initialValues !== initialValues) {
            this.handleSuggestionClick(initialValues.company);
        }
    }

    handleInputChange = event => {
        const searchTerm = event.target.value;
        const { busCompanies } = this.props;
        let filteredOptions;
        if (searchTerm && busCompanies) {
            filteredOptions = busCompanies.filter(option =>
                option.companyName.toLowerCase().includes(searchTerm.toLowerCase()),
            );
        } else {
            filteredOptions = busCompanies;
        }
        this.setState({ searchTerm, open: true, filteredOptions });
    };

    handleBlur = () => {
        setTimeout(() => this.setState({ open: false }), 100);
    };

    render() {
        const { t, initialValues } = this.props;
        const { showForm, searchTerm, open, filteredOptions } = this.state;

        return (
            <div>
                {showForm && (
                    <div className="row">
                        <form className="form-horizontal" onSubmit={this.props.handleSubmit}>
                            <div className="col-md-12">
                                <Field
                                    name="description"
                                    label={`${t('invoice.description')} *`}
                                    component={renderInput}
                                />
                                <Field name="companyId" component="input" type="hidden" />
                            </div>

                            <div style={{ zIndex: 100000, paddingRight: 15, paddingLeft: 15, width: '100%' }}>
                                <TextField
                                    label={t('invoice.choose_operator')}
                                    floatingLabelText={t('invoice.choose_operator')}
                                    value={searchTerm}
                                    onChange={this.handleInputChange}
                                    onFocus={() =>
                                        this.setState({
                                            open: true,
                                            filteredOptions: this.props.busCompanies || [],
                                        })
                                    }
                                    onBlur={this.handleBlur}
                                    fullWidth
                                />

                                {open && filteredOptions.length > 0 && (
                                    <Paper
                                        style={{
                                            position: 'absolute',
                                            left: 0,
                                            width: '100%',
                                            maxHeight: 200,
                                            zIndex: 1000,
                                            overflowY: 'auto',
                                        }}>
                                        <MenuItem
                                            value={null}
                                            primaryText="-"
                                            key={null}
                                            onClick={() => this.handleSuggestionClick(null)}
                                        />
                                        {filteredOptions.map(option => (
                                            <MenuItem
                                                key={option.id || option.companyName}
                                                value={option.companyName}
                                                onMouseDown={() => {
                                                    this.handleSuggestionClick(option);
                                                }}>
                                                {option.companyName}
                                            </MenuItem>
                                        ))}
                                    </Paper>
                                )}
                            </div>

                            <div className="col-md-12" style={{ gap: 10, display: 'flex', marginTop: 10 }}>
                                <RaisedButton
                                    primary={true}
                                    type="submit"
                                    label={
                                        initialValues !== undefined ? t('geofence.form.update') : t('geofence.form.add')
                                    }
                                />
                                <RaisedButton
                                    secondary={true}
                                    label={t('geofence.form.clear')}
                                    onClick={() => {
                                        this.props.handleDeletePolygon();
                                    }}
                                />
                            </div>
                        </form>
                    </div>
                )}
            </div>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};
    if (isBlank(values.description)) errors.description = t('error_missing.fill_in_name_description');
    return errors;
};

export default reduxForm({
    form: 'customFeeMapForm',
    validate,
    enableReinitialize: true,
})(CustomFeeMapForm);
